import { PERIOD_TYPE } from '../constants';
import { splitQuantityValue } from './computeStartEnd';

// check if start and end time is on same calendar day
const isSameUtcDay = (start, end) => start.toISOString().slice(0, 10) === end.toISOString().slice(0, 10);

const toUtcDateString = (date) => {
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');
  const year = date.getUTCFullYear();
  return `${month}/${day}/${year}`;
};

export const buildInitialValues = (interaction) => {
  const procedure = interaction.procedures?.[0];
  const start = new Date(procedure?.performed_start_time ?? interaction.start_time);
  const end = new Date(procedure?.performed_end_time ?? interaction.end_time);
  const isSingle = isSameUtcDay(start, end);
  const { hours, minutes } = splitQuantityValue(procedure?.quantity_value);

  return {
    codeConceptId: procedure?.code_concept?.id,
    periodType: isSingle ? PERIOD_TYPE.SINGLE : PERIOD_TYPE.RANGE,
    singleDate: isSingle ? toUtcDateString(start) : undefined,
    rangeStart: !isSingle ? toUtcDateString(start) : undefined,
    rangeEnd: !isSingle ? toUtcDateString(end) : undefined,
    hours,
    minutes,
    note: interaction.note || '',
  };
};
